import React from "react";
import styled from "styled-components";
import { SEC_FONT_GREY } from "../../constant/colors";
import { translatePlanMarket, PLAN_MARKETS } from "../../constant/planMarkets";
import { UNSPECIFIED_PAYER_NAME } from "../../constant/coverages";
import { useGetSetting } from "../../hooks/getSetting";
import { Typography } from "antd";
import { getStatusTagStyle, getStatusTagHoverBackground, getStatusTagHoverBorder } from "../../util/statusTagStyles";
const { Text } = Typography;

const StatusTagText = styled(Text)`
  cursor: pointer;
  transition: background-color 120ms ease, border-color 120ms ease;
  &:hover {
    background: var(--tm-status-hover-bg) !important;
    border-color: var(--tm-status-hover-border) !important;
  }
`;

export const StatusPill = ({ label, colorMap, style: extraStyle }) => (
  <StatusTagText
    style={{
      ...getStatusTagStyle(label, colorMap),
      "--tm-status-hover-bg": getStatusTagHoverBackground(label, colorMap),
      "--tm-status-hover-border": getStatusTagHoverBorder(label, colorMap),
      ...(extraStyle || {})
    }}
  >
    {label}
  </StatusTagText>
);

export const PatientStatusCell = ({ value }) => {
  const [statuses] = useGetSetting(["statuses"]);
  const status = statuses.find((status) => status.value === value);
  const textualValue = status ? status.text : "";
  return <StatusPill label={textualValue} />;
};

export const patientInsuranceCell = (insuranceType) => (_, record) => {
  const planMarket = record[`${insuranceType}InsurancePlanMarket`] || "";
  const payer = planMarket === PLAN_MARKETS.Uninsured ? "" : record[`${insuranceType}InsurancePayerName`] || "";

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div className="primary-insurance-payer">{payer === UNSPECIFIED_PAYER_NAME ? "--" : payer}</div>
      <div style={{ color: SEC_FONT_GREY }}>{planMarket && translatePlanMarket(planMarket)}</div>
    </div>
  );
};
